import { useLang } from "@/context/LanguageContext";

export const SeoText = () => {
  const { t } = useLang();
  const s = t.seo;
  return (
    <section className="border-t border-white/5 bg-[#0c0c0c]" data-testid="seo-text-section">
      <div className="max-w-6xl mx-auto px-6 py-14">
        <h2 className="text-base md:text-lg font-semibold text-white/70 mb-4">{s.title}</h2>
        <div className="grid md:grid-cols-3 gap-8 text-sm leading-relaxed text-white/40">
          <div>
            <h3 className="text-white/60 font-semibold mb-2">{s.h1}</h3>
            <p>{s.p1}</p>
          </div>
          <div>
            <h3 className="text-white/60 font-semibold mb-2">{s.h2}</h3>
            <p>{s.p2}</p>
          </div>
          <div>
            <h3 className="text-white/60 font-semibold mb-2">{s.h3}</h3>
            <p>{s.p3}</p>
          </div>
        </div>
      </div>
    </section>
  );
};
